import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import Bowser from "bowser";
import { unsupportedBrowsers } from "./unsupportedBrowsers";
import { App } from "./App";
import packageJson from "../package.json";
import { UpgradeBrowser } from "./views/shared/UpgradeBrowser";
import { STORAGE } from "./constants";

// Browser check works as a black list (blocked) rather than white list (accepted)
//  users who's browser meets certain criteria as shown the unsupported browser warning
//  they can always proceed anyways if they know better
const browser = Bowser.getParser(window.navigator.userAgent);
const isUnsupportedBrowser = browser.satisfies(unsupportedBrowsers);
const browserBypass =
  window.localStorage.getItem(STORAGE.browserBypass) === "true";

const startupLog =
  "environment: " + process.env.NODE_ENV + "; version: " + packageJson.version;

console.log(startupLog);
if (isUnsupportedBrowser) {
  console.log("Bowser.getParser", browser);
}

ReactDOM.render(
  isUnsupportedBrowser && !browserBypass ? (
    <UpgradeBrowser />
  ) : (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  ),
  document.getElementById("root")
);
